import { vscodeTheme } from '../../styles/theme';
import type { AppError } from '../../api/errors';

interface ApiErrorNoticeProps {
  error: AppError | null;
}

export function ApiErrorNotice({ error }: ApiErrorNoticeProps) {
  if (!error) {
    return null;
  }

  return (
    <div style={{ color: '#f48771', fontSize: '13px', marginBottom: '8px' }}>
      <div>{error.message}</div>
      <div style={{ color: vscodeTheme.colors.textSecondary }}>
        Request ID: {error.error.request_id}
      </div>
    </div>
  );
}
